module.exports = __webpack_public_path__ + "211f422a.svg";